const Login = () => import('../pages/auth/login').then((m) => m.default || m)
const Register = () => import('../pages/auth/register').then((m) => m.default || m)
const Verification = () => import('../pages/auth/verification').then((m) => m.default || m)
const PostVerification = () => import('../pages/auth/postVerification').then((m) => m.default || m)
const Verify = () => import('../pages/auth/verify').then((m) => m.default || m)
const SetPassword = () => import('../pages/auth/setPassword').then((m) => m.default || m)
const TeamInvitation = () => import('../pages/auth/teamInvitation').then((m) => m.default || m)
const PasswordEmail = () => import('../pages/auth/password/email').then((m) => m.default || m)
const PasswordReset = () => import('../pages/auth/password/reset').then((m) => m.default || m)
const OtpChallenge = () => import('../pages/auth/otp-challenge').then((m) => m.default || m)
const WixAutologin = () => import('../pages/auth/wix-autologin').then((m) => m.default || m)
const NotFound = () => import('../pages/errors/404').then((m) => m.default || m)
const Home = () => import('../pages/home').then((m) => m.default || m)
const SuppliersTermsConditions = () => import('../pages/suppliers-terms-conditions').then((m) => m.default || m)
const Partners = () => import('../pages/partners').then((m) => m.default || m)

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
  },
  {
    path: '/growyourbusiness',
    name: 'grow-your-business',
    component: Register,
  },
  {
    path: '/verification',
    name: 'verification',
    component: Verification,
  },
  {
    path: '/post-verification',
    name: 'post-verification',
    component: PostVerification,
  },
  {
    path: '/setPassword/:token',
    name: 'setPassword',
    component: SetPassword,
  },
  {
    path: '/team-invitation/:token',
    name: 'team-invitation',
    component: TeamInvitation,
  },
  {
    path: '/verify/:token',
    name: 'verify',
    component: Verify,
  },
  {
    path: '/password/reset',
    name: 'password.request',
    component: PasswordEmail,
  },
  {
    path: '/password/reset/:token',
    name: 'password.reset',
    component: PasswordReset,
  },
  {
    path: '/otp-challenge/:sessionKey',
    name: 'otp.challenge',
    component: OtpChallenge,
    props: (route) => ({ sessionKey: route.params.sessionKey, continue: route.query.continue }),
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
  },
  {
    path: '/suppliers-terms-conditions',
    name: 'suppliers-terms-conditions',
    component: SuppliersTermsConditions,
  },
  {
    path: '/partners',
    name: 'partners',
    component: Partners,
  },
  {
    path: '/wix-autologin',
    name: 'wix-autologin',
    component: WixAutologin,
  },
  {
    path: '*',
    component: NotFound,
  },
]
